<template>
  <div
    class="wrapper-report  "
    :style="{
      'z-index': '3'
    }"
  >
    <aha-toggle-tip
      to="accuracy-box"
      :text="$i18nPresenter.t('Average participant accuracy on questions with correct answers')"
    >
    </aha-toggle-tip>
    <aha-toggle-tip
      to="submission-box"
      :text="tooltipGuide"
    >
    </aha-toggle-tip>
    <div class="mx-auto">
      <page-breadcrumb
        :category="breadcrumbsCategory"
        :text="$i18nPresenter.t('Report')"
        :n-level-array="breadcrumbsMultipleLevelArray"
        @clickNLevel="clickBreadcrumbsNLevel"
        isSecondLevelClickable
        @clickSecondLevel="backToPreviousPage()"
        :title="presentation.name"
      />
      <div class="flex flex-col gap-4">
        <!--        info presentation start-->
        <div class="flex w-full wrapper-toolbox justify-between align-middle gap-4">
          <div class="section-info-presentation flex">
            <span
              class=" min-w-max flex items-center text-sm md:text-base"
              :content="$i18nPresenter.t('Number of slides')"
              v-aha-tooltip="{ arrow : true }"
            >
              <aha-icon
                class="mr-1 base-color"
                name="slides"
                width="16"
                height="16"
                viewBox="0 0 12 12"
              />
              <span>
                {{ presentation.slideCount }}
              </span>
            </span>

            <div
              :content="$i18nPresenter.t('Presentation creation date and time')"
              v-aha-tooltip="{ arrow : true }"
              class="flex items-center  min-w-max time-box-report"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                class="mr-1"
              >
                <path d="M7.46814 5.93543V8.06336C8.29688 8.24771 9.03353 8.55081 9.80511 8.76017V6.62911C8.97955 6.44788 8.23655 6.14478 7.46814 5.93543ZM14.5584 2.09204C13.4693 2.58886 12.1294 3.08882 10.8434 3.08882C9.14467 3.08882 7.73804 2.00142 5.59793 2.00142C4.80413 2.00142 4.09605 2.13891 3.43878 2.37638C3.52768 2.14828 3.56896 1.90143 3.55308 1.63895C3.49593 0.751534 2.7561 0.0391002 1.85116 0.0016037C0.835086 -0.0390175 0 0.760908 0 1.75144C0 2.34514 0.301647 2.87009 0.762056 3.18568V15.2502C0.762056 15.6658 1.10181 16.0001 1.52411 16.0001H2.03215C2.45445 16.0001 2.7942 15.6658 2.7942 15.2502V12.3005C3.69279 11.9224 4.81365 11.6099 6.42667 11.6099C8.12859 11.6099 9.53205 12.6973 11.6722 12.6973C13.2026 12.6973 14.4251 12.188 15.5618 11.4193C15.8381 11.2318 16 10.9256 16 10.5944V2.9982C16.0032 2.27014 15.2316 1.78581 14.5584 2.09204ZM5.13117 10.1725C4.31196 10.2569 3.54356 10.4288 2.7942 10.6912V8.48832C3.62611 8.19772 4.30244 8.01961 5.13117 7.94462V10.1725ZM14.4791 5.9698C13.7297 6.27602 13.0089 6.57912 12.1421 6.71661V8.93828C12.9295 8.83204 13.7742 8.56956 14.4791 8.12585V10.3288C13.6821 10.8319 12.9391 11.1006 12.1421 11.1756V8.93828C11.2848 9.05389 10.6211 8.98515 9.80511 8.76329V10.8693C9.04623 10.6381 8.30323 10.3475 7.46814 10.2038V8.06336C6.84262 7.92587 6.17265 7.85088 5.13117 7.94462V5.75732C4.41992 5.85419 3.71502 6.07604 2.7942 6.41039V4.20746C3.84838 3.82625 4.38499 3.58877 5.13117 3.52003V5.75732C5.98849 5.64171 6.66799 5.7167 7.46814 5.93543V3.82937C8.22067 4.0606 8.96685 4.3512 9.80511 4.49494V6.63224C10.5576 6.79785 11.3165 6.84784 12.1421 6.71661V4.46994C12.9994 4.31995 13.8027 4.04498 14.4791 3.76688V5.9698Z" fill="#525F7F" />
              </svg>

              <div class="font-light text-sm md:text-base">
                {{ moment(presentation.createdAt).format('DD MMM YYYY, hh:mm A') }}
              </div>
            </div>
          </div>

          <div class="flex gap-2">
            <ExportSectionV2 v-if="canUseReportExportSlide" class="hidden flex-1 sm:flex-none sm:order-2 md:flex" />
            <ExportSection v-else class="hidden flex-1 sm:flex-none sm:order-2 md:flex" />
            <ExportSectionV2
              v-if="canUseReportExportSlide"
              :size="'xl'"
              class="flex-1 sm:flex-none sm:order-2 md:hidden"
            />
            <ExportSection
              v-else
              :size="'xl'"
              class="flex-1 sm:flex-none sm:order-2 md:hidden"
            />
            <aha-button
              :size="'xl'"
              class="bg-white flex-1 sm:flex-none md:hidden"
              :variant="'base'"
              @click="backToPresentation"
            >
              <aha-icon
                height="20"
                name="edit-2"
                viewBox="0 0 20 20"
                class="mr-2"
              />
              {{ $i18nPresenter.t('View slides') }}
            </aha-button>
            <aha-button
              class="hidden bg-white flex-1 sm:flex-none md:flex"
              :variant="'base'"
              @click="backToPresentation"
            >
              <aha-icon
                height="20"
                name="edit-2"
                viewBox="0 0 20 20"
                class="mr-2"
              />
              {{ $i18nPresenter.t('View slides') }}
            </aha-button>
          </div>
        </div>
        <!-- info presentation end-->
        <!--        desktop 4 grid ipad 2 grid  -->
        <section class="info-section">
          <section class="overal-report-section">
            <div
              class="metric-box"
              v-hover-intent="{
                onEnter:() => {},
                onExit: () => trackingHereSection('Total participant',),
              }"
              :content="$i18nPresenter.t('Total number of participants joined')"
              v-aha-tooltip="{ arrow: true }"
              @click="handleTabChange('participants')"
            >
              <aha-icon
                name="circle-audience"
                maintainColor
                width="52"
                viewBox="0 0 52 52"
              />
              <aha-icon
                name="circle-audience-color"
                maintainColor
                width="52"
                viewBox="0 0 52 52"
              />
              <div class="flex flex-col gap-1 md:gap-2">
                <div v-if="isLoadingReport" class="text-metric">
                  <aha-skeleton-loader
                    width="100%"
                    height="20px"
                  />
                </div>
                <div
                  v-else-if="!isLoadingReport && reportMetric
                    && reportMetric.totalAudience !== 0 "
                  class="text-metric"
                >
                  {{ (reportMetric && reportMetric.totalAudience || 0 )| formatNumber }}
                </div>
                <div class="text-explain-metric">
                  {{ reportMetric && reportMetric.totalAudience !== 0
                    ? $i18nPresenter.t('Total participants') : $i18nPresenter.t('No participants') }}
                </div>
              </div>
            </div>
            <div
              class="metric-box cursor-auto"
              v-hover-intent="{
                onEnter:() => {},
                onExit: () => trackingHereSection('Reactions',),
              }"
              v-aha-tooltip="{
                content: reactionTooltipContent,
                allowHTML: true, arrow: true,
              }"
            >
              <aha-icon
                name="circle-heart"
                maintainColor
                width="52"
                viewBox="0 0 52 52"
              />
              <aha-icon
                name="circle-heart-color"
                maintainColor
                width="52"
                viewBox="0 0 52 52"
              />
              <div class="flex flex-col gap-1 md:gap-2">
                <div v-if="isLoadingReport" class="text-metric">
                  <aha-skeleton-loader
                    width="100%"
                    height="20px"
                  />
                </div>
                <div class="text-metric" v-else-if="!isLoadingReport && !emptyReactions">
                  {{ numberOfReactions }}
                </div>
                <div class="text-explain-metric">
                  {{ emptyReactions
                    ? $i18nPresenter.t('No reactions') : $i18nPresenter.t('Total Reactions') }}
                </div>
              </div>
            </div>
            <div
              class="metric-box"
              name="submission-box"
              v-hover-intent="{
                onEnter:() => {},
                onExit: () => trackingHereSection('Avg. submissions',),
              }"
              @click="handleTabChange('participants')"
            >
              <aha-icon
                name="circle-submission"
                maintainColor
                width="52"
                viewBox="0 0 52 52"
              />
              <aha-icon
                name="circle-submission-color"
                maintainColor
                width="52"
                viewBox="0 0 52 52"
              />
              <div class="flex flex-col gap-1 md:gap-2">
                <div v-if="isLoadingReport" class="text-metric">
                  <aha-skeleton-loader
                    width="100%"
                    height="20px"
                  />
                </div>
                <div v-else-if="noSubmission" class="text-metric">
                  {{ formatNumberForMetric(reportMetric && reportMetric.averageSubmissionCount ) | formatNumber }}
                </div>
                <div class="text-explain-metric">
                  {{ noSubmission ? $i18nPresenter.t('Avg. submissions') : $i18nPresenter.t('No submissions') }}
                </div>
              </div>
            </div>
            <div
              class="metric-box"
              v-hover-intent="{
                onEnter:() => {},
                onExit: () => trackingHereSection('Accuracy',),
              }"
              name="accuracy-box"
              @click="handleTabChange('participants')"
            >
              <aha-icon
                name="circle-check-mark"
                maintainColor
                width="52"
                viewBox="0 0 52 52"
              />
              <aha-icon
                name="circle-check-mark-color"
                maintainColor
                width="52"
                viewBox="0 0 52 52"
              />
              <div class="flex flex-col gap-1 md:gap-2">
                <div v-if="isLoadingReport" class="text-metric">
                  <aha-skeleton-loader
                    width="100%"
                    height="20px"
                  />
                </div>
                <div class="text-metric" v-else-if="!isLoadingReport && noAnswer">
                  {{ reportMetric && Math.round(((reportMetric && reportMetric.totalAccuracy) || 0 ) * 100) }} %
                </div>
                <div class="text-explain-metric">
                  {{ noAnswer
                    ? $i18nPresenter.t('Accuracy') : $i18nPresenter.t('No answers') }}
                </div>
              </div>
            </div>
            <div
              class="metric-box"
              @click="handleTabChange('feedback')"
              v-hover-intent="{
                onEnter:() => {},
                onExit: () => trackingHereSection('Ratings',),
              }"
              :content="$i18nPresenter.t('Average rating by participants')"
              v-aha-tooltip="{ arrow: true }"
            >
              <aha-icon
                name="circle-star"
                maintainColor
                width="52"
                viewBox="0 0 52 52"
              />
              <aha-icon
                name="circle-star-color"
                maintainColor
                width="52"
                viewBox="0 0 52 52"
              />
              <div class="flex flex-col gap-1 md:gap-2">
                <div v-if="isLoadingReport" class="text-metric">
                  <aha-skeleton-loader
                    width="150px"
                    height="20px"
                  />
                </div>
                <div
                  v-else-if="!isLoadingReport && totalRatings > 0"
                  class="text-metric flex flex-row justify-start items-center gap-2"
                >
                  {{ avgRating }}
                  <div>
                    <AhaStarRatingView
                      class="flex justify-center"
                      :rate="Number(avgRating)"
                      size="16px"
                    />
                  </div>
                </div>
                <div v-if="isLoadingReport" class="text-metric">
                  <aha-skeleton-loader
                    width="50px"
                    height="20px"
                  />
                </div>
                <div class="text-explain-metric" v-else>
                  {{ totalRatings === 0 ? $i18nPresenter.t('No ratings') : (totalRatings > 1
                    ? $i18nPresenter.t('x ratings', { number: totalRatings })
                    : $i18nPresenter.t('x rating', { number: totalRatings })
                  ) }}
                </div>
              </div>
            </div>
          </section>
          <section class="preview-section">
            <SlidesPreview
              :presentation="presentation"
            ></SlidesPreview>
          </section>
        </section>
        <div class="wrapper-table">
          <div class="modal__title--tab title-tab__content-wrapper">
            <a
              @click="handleTabChange('participants')"
              class="title-tab__content"
              :class="{ active: selectedTab === 'participants' }"
            >
              {{ $i18nPresenter.t('Participants') }} <span class="inline-block" v-if="isLoadingReport">
                <aha-skeleton-loader
                  width="20px"
                  height="15px"
                />
              </span>
              <span v-else class="ml-2">({{ (reportMetric && reportMetric.totalAudience || 0 ) | formatNumber }})</span>
            </a>
            <a
              @click="handleTabChange('feedback')"
              :class="{ active: selectedTab === 'feedback' }"
              class="title-tab__content"
            >
              {{ $i18nPresenter.t('Feedback') }} <span class="inline-block" v-if="isLoadingReport">
                <aha-skeleton-loader
                  width="20px"
                  height="15px"
                />
              </span>
              <span v-else class="ml-2">({{ feedbackList.length || 0 }})</span>
            </a>
          </div>
          <ReportPrivateFeedbackV2
            v-if="selectedTab === 'feedback'"
            :oldFeedbacks="privateFeedbacks"
            :newFeedbacks="newPrivateFeedbacks"
          />
          <ListParticipant
            v-if="selectedTab === 'participants'"
            :audienceReport="audienceReport"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// components
import SlidesPreview from '@/components-v2/presentation-report/SlidesPreview.vue'
import ReportPage from '@/components-v2/presentation-report/ReportPage.vue'
import Reactions from '@/components-v2/my-presentations/main-table/Reactions.vue'
import ExportSectionV2 from '@/components-v2/presentation-report/ExportSectionV2.vue'

export default {
  components: {
    ...ReportPage.components,
    SlidesPreview,
    ExportSectionV2,
  },
  extends: ReportPage,
  computed: {
    ...ReportPage.computed,
    ...Reactions.computed,
    ...mapGetters('featureToggles', [
      'canUseReportExportSlide',
    ]),
    tooltipGuide() {
      return this.$i18nPresenter.t('Average number of submissions per participant on polls, word clouds, scales, open-ended questions, brainstorming, Q&A')
    },
    emptyReactions() {
      return this.numberOfReactions === 0
    },
    reactionTooltipContent() {
      return this.emptyReactions ? this.$i18nPresenter.t('Total number of reactions from participants') : this.iconTooltipContent
    },
  },
}
</script>

<style lang="scss" scoped>

@import "@/assets/scss-v2/variables.scss";
.wrapper-report{
  padding: 24px 40px 120px 40px;
  @media (max-width: 1024px) {
    padding: 24px 1rem 90px 1rem;
  }
}
.wrapper-toolbox{
  flex-direction: column;

  @media (min-width: 768px) {
    flex-direction: row;
  }
}
.aha-button-base{
  background: white;
}
.base-color{
  color:#525F7F;
}
.section-info-presentation {
  display: flex;
  gap: 1rem;

  font-size: 16px;
  .text-reaction{
    font-size: 16px;
  }
}
.info-section {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  border-radius: 0.5rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(12, 1fr);
    background-color: white;
    padding: 0.75rem;
  }

  .overal-report-section {
    --metric-box-height-desktop: 116px;
    --metric-box-height-tablet: 134px;
    padding: 0.5rem;
    background-color: white;
    display: grid;
    border-radius: 0.5rem;

    @media (min-width: 768px) {
      padding: 0px;
      background-color: transparent;
      grid-column: 1 / 7;
      gap: 0.75rem;
      grid-template-columns: repeat(2, 1fr);
      grid-auto-rows: max-content;
    }

    @media (min-width: 1024px) {
      grid-column: 1 / 9;
      grid-template-columns: repeat(3, 1fr);
      grid-auto-rows: minmax(var(--metric-box-height-desktop), max-content);
    }

    @media (min-width: 1366px) {
    }

    & .metric-box {
      border-radius: none;
      padding: 0.5rem;
      gap: 0.75rem;

       & .text-metric {
        font-size: 16px;
       }

       & .text-explain-metric {
        font-size: 14px;
       }

      @media (min-width: 768px) {
        & .text-metric {
          font-size: 20px;
        }

        & .text-explain-metric {
          font-size: 14px;
        }
        padding: 0.75rem;
        flex-direction: column;
        align-items: start;

        & img {
          width: 52px;
        }

        & > div {
          padding: 0;
        }
      }

      @media (min-width: 1366px) {
        flex-direction: row;
        align-items: center;
      }
    }
  }

  .preview-section {
    border-radius: 0.5rem;
    background-color: white;

    @media (min-width: 768px) {
      grid-column: 7 / 13;

      & .sharing-view {
        background-color: #F0F4FA;
        border: #F0F4FA 2px solid;
        border-radius: 0.5rem;
      }
    }

    @media (min-width: 1024px) {
      grid-column: 9 / 13;
    }
  }
}

.wrapper-table{
  @apply bg-base-0 gap-4  rounded-md;
}
.title-tab {
  padding: 16px 24px 0px 24px;
  border-bottom: 1px solid #ddd;

  a {
    display: inline-block;
    padding: 0 16px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    padding-bottom: 10px;
    margin-bottom: -1px;

    &.active {
      border-bottom: 3px solid #4f9af2;
      color: #4f9af2;
    }
  }
}

.report-panel {
  @apply bg-base-0 w-full p-4 pb-40 transition-all shadow-top bg-no-repeat;
  @apply right-0 overflow-y-scroll;
  @apply h-full fixed;
  @apply top-16;
  background-size: 100%;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;  /* Hide scrollbar on IE and Edge */
  scrollbar-width: none;

  .report-panel-export {
    display: block;
  }

  &.in-editor {
    width: 100%;
    .report-panel-export {
      display: none;
    }
  }

  @media (min-width: 768px) { // sm screens
    min-height: calc(100vh - 4rem); // header height is 4rem
    width: 354px;
    &.in-editor {
      width: $rightSideWidth;
      @apply top-32;
    }
  }
}
.body-table{
  height: 400px;
  overflow-y: scroll;
  -ms-overflow-style: auto;
}

.report-engagement-rate {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 12px;
  width: 100%;
  background: #FFFFFF;
  box-shadow: 0px 2px 6px rgba(211, 215, 225, 0.65);
  border-radius: 8px;
}

.nav-tabs {
  display: flex;
  margin-left: -1rem;
  margin-right: -1rem;
  border-top: 1px solid #EBEBEB;

  .nav-item {
    @apply bg-secondary-15 text-center text-secondary-40 cursor-pointer;
    @apply flex justify-center items-center flex-1;
    padding: 14px;

    &.active {
      @apply bg-base-0;
      color: #191F2D;
    }
  }
}
.metric-box {
  cursor: pointer;

  &.cursor-auto {
    cursor: auto;
  }
  svg {
    width: 48px;
    height: 48px;

    @media (min-width: 768px) {
      width: 52px;
      height: 52px;
    }

    &:nth-child(1) {
      display: inline-block;
    }

    &:nth-child(2) {
      display: none;
    }
  }
  height:100%;
  align-items: center;
  @apply bg-base-0 gap-4 rounded-md flex flex-row;
  .text-metric{
    font-size: 20px;
    // bold
    font-weight: bold;
  }
  .text-explain-metric{
    font-size: 16px;
  }

  &:hover {
    background-color: #F0F4FAB2;

    & svg {
      &:nth-child(1) {
        display: none;
      }

      &:nth-child(2) {
        display: inline-block;
      }
    }
  }
}
.content__mobile-screen {
  @apply sm:mt-20 mt-12;
  display: none;

  text-align: center;
  @media (max-width:  1024px) {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
}
.header{
  svg{
    cursor: pointer;
  }
}
.modal__title--tab {
  padding: 0 16px;
  border-bottom: 1px solid #ddd;

  a {
    display: inline-block;
    padding: 0 16px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    padding-bottom: 10px;
    margin-bottom: -1px;

    &.active {
      border-bottom: 3px solid #4f9af2;
      color: #4f9af2;
    }
  }
  &.title-tab__content-wrapper {
    @apply flex overflow-x-auto overflow-y-hidden;
    padding: 16px 16px 0 16px;
  }
  .title-tab__content {
    @apply flex;
  }
}
</style>
